import $ from 'jquery';
import 'slick-carousel'; // Ensure slick-carousel is imported
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { useEffect } from 'react';
import './Banner.css'

const Banner = ({ slider }) => {
  useEffect(() => {
    const $slider = $('.slider-1');
    console.log('Slider found:', $slider.length); // 👈 Add this
  
    if ($slider.length && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        adaptiveHeight: false,
      });
    } else {
      console.error('Slider element not found or already initialized');
    }
  
    return () => {
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    };
  }, []);
  return (
    <>


      <div className="row justify-content-center text-center">
        <div className="col-12">
          <div className="slider-1 slider-animate product-wrapper no-arrow">
            {slider.map((item, key) => (
              <div key={key} className="slick-slide position-relative">
                <div className="d-flex justify-content-center position-relative">

                  {/* Image container with position-relative for button overlay */}
                  <div className="banner-contain-2 hover-effect bg-size blur-up lazyloaded position-relative w-100">
                    <div
                      className="image-container d-flex justify-content-center align-items-center"
                      style={{ height: "100%", width: "100%" }}
                    >
                      {(() => {
                        const isVideo = item.img_url?.toLowerCase().endsWith(".mp4");
                        const mediaSrc = process.env.REACT_APP_API_BASE_URL + item.img_url;

                        if (isVideo) {
                          return (
                            <video
                              src={mediaSrc}
                              autoPlay
                              loop
                              muted
                              playsInline
                              className="rounded-3"
                              style={{
                                display: "block",
                                margin: "0 auto",
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            ></video>
                          );
                        } else {
                          return (
                            <img
                              src={mediaSrc}
                              className="rounded-3 lazyload"
                              alt=""
                              style={{
                                display: "block",
                                margin: "0 auto",
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                          );
                        }
                      })()}
                    </div>

                  
                  </div>
                </div>
              </div>
            ))}
            
          </div>
            {/* Button placed at bottom center of image */}
           
        </div>
      </div>

    </>
  );
};

export default Banner;
